<rotec-modal-v2 [darkMode]="true" [width]="width" [summary]="summary">
  <ng-container ngProjectAs="modal-main">
    <div class="text" translate>
      {{ 'You are about to copy the correction location settings from' | translate }}
      <span>{{ sideFromText | translate }}</span> {{ 'to' | translate }}
      <span>{{ sideToText | translate }}</span
      >.
    </div>
    <div class="text" translate>
      {{ 'All current settings on' | translate }} {{ sideToText | translate }}
      {{ 'will be overwritten' | translate }}.
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-secondary dark (click)="cancel()">
      {{ 'COMMON_Cancel' | translate }}
    </button>
    <button rotec-button-warning dark (click)="confirm()">{{ 'Copy' | translate }}</button>
  </ng-container>
</rotec-modal-v2>
